import {
  makeStyles,
  Typography,
  Box,
  Divider,
  Paper,
  RadioGroup,
  Radio,
  Icon,
} from "@material-ui/core";
import { useState } from "react";
import RefillCategoryForm from "./refill-category-form";
import BasalCategoryForm from "./basal-category-form";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { WarningRounded } from "@material-ui/icons";
export default function CategoryForm(props) {
  const { options, onSubmit } = props;
  const [refillCategoryType, setRefillCategoryType] = useState("basal");
  const classes = useStyles();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const hasBasal = Boolean(query.get("b"));
  return (
    <Paper className={classes.custom_paper}>
      <Box className={classes.container_fields}>
        <Box component={"section"} className={classes.section_form}>
          <Typography variant="h6">Tipo de categoria</Typography>
          <Divider style={{ marginBottom: 12, marginTop: 6 }} />
          <RadioGroup
            style={{ flexDirection: "row", gap: 12 }}
            onChange={(e) => setRefillCategoryType(e.target.value)}
          >
            <Typography
              component={"label"}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Radio
                name="type"
                value={"basal"}
                checked={refillCategoryType === "basal"}
              />
              Basal
            </Typography>
            <Typography
              component={"label"}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Radio
                name="type"
                value={"refill"}
                checked={refillCategoryType === "refill"}
              />
              Refill
            </Typography>
          </RadioGroup>
        </Box>
        {refillCategoryType === "basal" && (
          <>
            {!hasBasal ? (
              <BasalCategoryForm
                onSubmit={(data) => onSubmit(data, refillCategoryType)}
              />
            ) : (
              <Box className={classes.basal_category_alert}>
                <Typography>
                  Ya tiene una categoria basal registrada, no puede crear otra.
                </Typography>
              </Box>
            )}
          </>
        )}
        {refillCategoryType === "refill" && (
          <RefillCategoryForm
            options={options}
            onSubmit={(data) => onSubmit(data, refillCategoryType)}
          />
        )}
      </Box>
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  custom_paper: {
    padding: theme.spacing(3),
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(1),
    },
  },
  container_fields: {
    maxHeight: "75vh",
    overflowY: "auto",
    [theme.breakpoints.only("xs")]: {
      maxHeight: "70vh",
    },
  },
  section_form: {
    margin: theme.spacing(2),
  },
  basal_category_alert: {
    borderRadius: theme.spacing(2),
    backgroundColor: `hsl(from ${theme.palette.warning.main} h s calc(l + 40))`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
}));
